module.exports = __webpack_public_path__ + "static/media/wheelIn.38919ebb.png";